<div>
  <div class="headers">
    <div class="filter-section-wrapper">
      <app-filter
        [filterBy]="sortBy"
        [label]="'Sort by:'"
        [filterByOptions]="sortByOptions"
        (filterByChanged)="onSortByChange($event)"
      ></app-filter>
    </div>
    @if (feedbacks.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'deeproots-feedback'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>

  <div class="feedback-section">
    @if (loading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading feedback...</p>
      </div>
    } @else if (feedbacks.length === 0) {
      <div class="no-results">
        <p>No feedback found.</p>
      </div>
    } @else {
      <div class="feedback-cards">
        @for (feedback of feedbacks; track $index) {
          <div
            class="feedback-card"
            tabindex="0"
            role="button"
            (click)="onCardClick(feedback)"
            (keydown.enter)="onCardClick(feedback)"
            (keydown.space)="onCardClick(feedback)"
          >
            <div class="card-header">
              <div class="rating-stars" [attr.data-rating]="feedback.rating">
                {{ getRatingStars(feedback.rating) }}
              </div>
              <div class="date">{{ formatDate(feedback.submitted_at) }}</div>
            </div>
            <div class="card-body">
              <div
                class="feedback-comment"
                [class.empty-comment]="!feedback.comment"
                [innerText]="feedback.comment || 'No comment provided.'"
              ></div>
            </div>
            <div class="card-footer">
              <div class="owner-info">
                @if (feedback.owner_name) {
                  <div class="owner-row">
                    <span class="owner-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"
                        />
                      </svg>
                    </span>
                    <span class="owner-name">{{ feedback.owner_name }}</span>
                  </div>
                }
                @if (feedback.email) {
                  <div class="owner-row">
                    <span class="owner-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"
                        />
                      </svg>
                    </span>
                    <span class="owner-email">{{ feedback.email }}</span>
                  </div>
                }
              </div>
              <div class="click-hint">Click to view</div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  @if (feedbacks.length > 0 && !loading) {
    <app-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="totalFeedbacks"
      (pageChanged)="onPageChange($event)"
    ></app-pagination>
  }

  @if (showPopup && selectedFeedback) {
    <app-popup
      [heading]="'Feedback Details'"
      [showFooterButtons]="false"
      [showCloseIcon]="true"
      (cancelClicked)="closePopup()"
    >
      <div class="popup-content">
        <div class="popup-meta-section">
          <div class="popup-meta-row">
            @if (selectedFeedback.owner_name) {
              <div class="popup-meta-item">
                <span class="popup-meta-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"
                    />
                  </svg>
                </span>
                <div class="popup-meta-detail">
                  <span class="popup-meta-label">Owner</span>
                  <span class="popup-meta-value">{{
                    selectedFeedback.owner_name
                  }}</span>
                </div>
              </div>
            }
            @if (selectedFeedback.email) {
              <div class="popup-meta-item">
                <span class="popup-meta-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"
                    />
                  </svg>
                </span>
                <div class="popup-meta-detail">
                  <span class="popup-meta-label">Email</span>
                  <a
                    class="popup-meta-value popup-meta-email"
                    [href]="'mailto:' + selectedFeedback.email"
                    >{{ selectedFeedback.email }}</a
                  >
                </div>
              </div>
            }
          </div>
          <div class="popup-meta-row popup-meta-row--secondary">
            <div class="popup-meta-item">
              <span class="popup-meta-icon popup-meta-icon--rating">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 328 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L398.1 328l104.2-102.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L340.9 150.3 316.9 18z"
                  />
                </svg>
              </span>
              <div class="popup-meta-detail">
                <span class="popup-meta-label">Rating</span>
                <span
                  class="popup-meta-value rating-stars-large"
                  [attr.data-rating]="selectedFeedback.rating"
                >
                  {{ getRatingStars(selectedFeedback.rating) }}
                </span>
              </div>
            </div>
            <div class="popup-meta-item">
              <span class="popup-meta-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112L0 176l640 0 0-64c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32C160 14.3 145.7 0 128 0zM640 224L0 224 0 512c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-288z"
                  />
                </svg>
              </span>
              <div class="popup-meta-detail">
                <span class="popup-meta-label">Submitted</span>
                <span class="popup-meta-value">{{
                  formatDate(selectedFeedback.submitted_at)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-body-section">
          <div class="comment-label">Feedback Comment</div>
          <div
            class="comment-content"
            [class.empty-comment]="!selectedFeedback.comment"
          >
            {{ selectedFeedback.comment || "No comment provided." }}
          </div>
        </div>
      </div>
    </app-popup>
  }
</div>
